import { Component, OnInit } from '@angular/core';
import { ScreeningService } from '../services/screening.service';
import { AuthService } from '../services/auth.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {
  UserName : string;
  Password : string;
  LoginError : boolean;
  ValidationMessage : string;
  redirectRoute : string;
  constructor(private location : Router, private activatedRoute: ActivatedRoute,private scrn : ScreeningService, private auth: AuthService, private toast : ToastrService, public cook : CookieService) { 
    auth.titleBarText = "STP Login"
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(
      (params: ParamMap) =>{
        this.redirectRoute = params.get('redirect');
      });
  }

  update(val : any) {
    console.log(val);
    if(val.name == 'UserName'){
      this.UserName = val.value;
    }else{
      this.Password = val.value;
    }
  }
  continue() {
    this.auth.GetToken(this.UserName,this.Password).subscribe((rsp : any)=>{
      console.log('login call returned',rsp);
      // localStorage.setItem('STP-JWT', rsp.token)
      this.cook.deleteAll();
      this.cook.set('resIq', rsp.token, 0.5, '/' , '.residentiq.com', true);
      window.location.href = environment.dashboardUrl + '/sso';
      // if(this.redirectRoute){
      //   window.location.href = 'http://'+ this.redirectRoute + '/'+rsp.token;
      // }else{
      //   this.toast.info('You have successfully logged in.');
      //   this.location.navigateByUrl(this.auth.postLoginRedirect);
      // }
    },
    (err : any)=>{
        this.LoginError = true;
        this.ValidationMessage = err.error;
    })
  }

  public uploadFile = (files) => {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('screeningId','3' );
    this.scrn.http.post(environment.baseURl + '/api/values/imgUpload', formData, {reportProgress: true, observe: 'events'})
      .subscribe(event => {
        //if (event.type === HttpEventType.UploadProgress)
          //this.progress = Math.round(100 * event.loaded / event.total);
         if (event.type === HttpEventType.Response) {
          console.warn(event);
        }
      });
  }


  public handleImageUpload(event : any) {
    let pld = new FileTransferPayload();
    if(event) {
      let reader = new FileReader();

      reader.readAsDataURL(event[0]);

      reader.onload = (rdrevent) => {
        let r = <FileReader>rdrevent.currentTarget;
        pld.base64FileString = r.result.toString();
        pld.fileName = event[0].name;
        pld.screeningId = 30000
        console.log(event);
        this.scrn.http.post(environment.baseURl + '/api/values/imgUpload', pld)
      .subscribe(event => {
        //if (event.type === HttpEventType.UploadProgress)
          //this.progress = Math.round(100 * event.loaded / event.total);
         
          console.warn(event);
        
      });
      }
    }
  }

}

export class FileTransferPayload {
  userId : number;
  clientId : number;
  base64FileString : string;

  screeningId : number;
  fileName : string;
}
